import { app } from '../../app.module'
/**
 * 時間を選択するフォーム。時間を選択した場合、イベントを送信する
 */
class HourFormComponentCtrl {
  private scope: ng.IScope
  private label: string
  private hours: string[]

  constructor($scope) {
    this.scope = $scope
    this.label = '時間'
    this.hours = [
      '指定しない',
      '0:00',
      '1:00',
      '2:00',
      '3:00',
      '4:00',
      '5:00',
      '6:00',
      '7:00',
      '8:00',
      '9:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00',
    ]
  }

  /**
   * 選択した時間をイベント送信する
   * @param  {string} selectedHour
   */
  public selectHour(selectedHour: string) {
    if (selectedHour === '指定しない') {
      selectedHour = null
    } else {
      // 時間のみを抜き出す(例: 23:00→23)
      if (selectedHour.length === 4) {
        selectedHour = selectedHour.substr(0, 1)
      } else {
        selectedHour = selectedHour.substr(0, 2)
      }
    }

    // イベントをemitする
    this.scope.$emit('changeFilterData', {
      type: 'hour',
      value: selectedHour,
    })
  }
}

app.component('hourForm', {
  template: require('./hour-form.pug')(),
  controller: HourFormComponentCtrl,
})
